<template>
  <div class="relative z-10 flex-1">
    <i class="fa-solid fa-search absolute left-2 top-7"></i>
    <input
      v-model="localValue"
      class="font-lg border-block rounded-2xl my-4 w-full border-gray-300 border p-2 pl-8 shadow"
      v-bind="$attrs"
    />
  </div>
</template>

<script>
import { ref } from "vue";
export default {
  components: {},
  props: {
    modelValue: {
      type: [String, Number],
      required: true,
    },
    debounce: {
      type: Number,
      default: 500,
    },
  },
  data() {
    return {
      timeout: ref(null),
    };
  },
  computed: {
    localValue: {
      get() {
        return this.modelValue;
      },
      set(newValue) {
        if (this.timeout) {
          clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(
          () => this.$emit("update:modelValue", newValue),
          this.debounce,
        );
      },
    },
  },
  beforeMount() {},
  methods: {},
};
</script>
